import {
  IRowPattern,
  createRowsFromConfig,
  createTiersFromConfig,
} from "@tedivo/tedivo-bay-grid-pure";

import { ICreateGridFromConfigProps } from "../../types/ICreateBayGridBaseProps";

/**
 * Rows and tiers of each part (above & below) of a grid created from config.
 * Shared by `createGridFromConfig` and `calculateGridFromConfigDimensions` so drawing and dimensions match.
 * Tiers are `undefined` when that part has no tier range.
 */
export function buildGridRowsAndTiers({
  minAboveTier,
  maxAboveTier,
  minBelowTier,
  maxBelowTier,
  centerLineRow,
  aboveCenterLineRow = centerLineRow,
  belowCenterLineRow = centerLineRow,
  maxRow,
}: Pick<
  ICreateGridFromConfigProps<unknown>,
  | "minAboveTier"
  | "maxAboveTier"
  | "minBelowTier"
  | "maxBelowTier"
  | "centerLineRow"
  | "aboveCenterLineRow"
  | "belowCenterLineRow"
  | "maxRow"
>): IGridRowsAndTiers {
  const aboveTiersArray =
    minAboveTier !== undefined && maxAboveTier !== undefined
      ? (createTiersFromConfig(minAboveTier, maxAboveTier) as IRowPattern[])
      : undefined;

  const belowTiersArray =
    minBelowTier !== undefined && maxBelowTier !== undefined
      ? (createTiersFromConfig(minBelowTier, maxBelowTier) as IRowPattern[])
      : undefined;

  return {
    aboveRowsArray: createRowsFromConfig(!!aboveCenterLineRow, maxRow),
    belowRowsArray: createRowsFromConfig(!!belowCenterLineRow, maxRow),
    aboveTiersArray,
    belowTiersArray,
  };
}

export interface IGridRowsAndTiers {
  aboveRowsArray: IRowPattern[];
  belowRowsArray: IRowPattern[];
  aboveTiersArray: IRowPattern[] | undefined;
  belowTiersArray: IRowPattern[] | undefined;
}
